import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import Catalogo from "../../../interfaces/catalogo";
import { useState } from "react";
import Gruppo from "../../../interfaces/gruppo";
import createCatalogo from "../../../api/catalogo/createCatalogo";
import updateCatalogo from "../../../api/catalogo/updateCatalogo";
import { BluAlert, BluLoader } from "@bludata/components";

interface Props {
  onClose: () => void;
  catalogo: Catalogo;
  gruppoList: Gruppo[];
  isEdit?: boolean;
}

function DialogModificaCatalogo(props: Props) {
  const { onClose, catalogo, gruppoList, isEdit = false } = props;
  const [descrizione, setDescrizione] = useState(catalogo.descrizione);
  const [gruppi, setGruppi] = useState(catalogo.gruppi || []);
  const [tipo, setTipo] = useState(catalogo.tipo);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const groupOptions = gruppoList.map((group) => {
    return { gruppo: group.codiceGruppo, descrizione: group.descrizione };
  });

  const onSaveClick = () => {
    const updatedCatalogo = {
      ...catalogo,
      descrizione,
      gruppi,
      tipo,
    };

    if (!isEdit) {
      if (!descrizione || !gruppi.length || !tipo) {
        setError("Tutti i campi sono obbligatori.");
        setLoading(false);
        return;
      }
    }

    setLoading(true);

    // If editing existing catalog, use updateCatalogo, otherwise createCatalogo
    const savePromise = isEdit
      ? updateCatalogo(catalogo.id!, updatedCatalogo)
      : createCatalogo({ ...updatedCatalogo, id: undefined });

    savePromise
      .then((response) => {
        onClose();
      })
      .catch((e) => {
        setError(
          e ||
            `Si è verificato un errore durante la ${
              isEdit ? "modifica" : "creazione"
            } del catalogo.`
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Dialog open fullWidth maxWidth="sm">
      <DialogTitle>
        {isEdit ? "Modifica catalogo" : "Crea un nuovo catalogo"}
      </DialogTitle>
      <DialogContent>
        <BluLoader open={loading} />
        <BluAlert
          show={!!error}
          handleClose={() => {
            setError("");
          }}
          text={error}
          type="error"
        />
        <Stack flexDirection="column" spacing={1}>
          <TextField
            label="Descrizione"
            value={descrizione}
            onChange={(e) => setDescrizione(e.target.value)}
          />
          <Stack flexDirection="row" gap={1}>
            <FormControl sx={{ flex: 1 }}>
              <InputLabel>Gruppi</InputLabel>
              <Select
                multiple
                value={gruppi.map((g) => g.gruppo) || []}
                onChange={(e) => {
                  const value = e.target.value;
                  const newGruppi = gruppoList.filter((g) =>
                    value.includes(g.codiceGruppo)
                  );
                  setGruppi(
                    newGruppi.map((group) => {
                      return {
                        gruppo: group.codiceGruppo,
                        descrizione: group.descrizione,
                      };
                    })
                  );
                }}
                renderValue={(selected) => {
                  return groupOptions
                    .filter((g) => selected.includes(g.gruppo))
                    .map((g) => g.descrizione)
                    .join(", ");
                }}
              >
                {groupOptions.map((g) => (
                  <MenuItem key={g.gruppo} value={g.gruppo}>
                    <Checkbox
                      checked={
                        !!gruppi.find((item) => item.gruppo === g.gruppo)
                      }
                    />
                    <ListItemText primary={g.descrizione} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label="Tipo"
              value={tipo}
              onChange={(e) => setTipo(e.target.value)}
            />
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={() => onClose()}>
          Annulla
        </Button>
        <Button variant="contained" onClick={onSaveClick}>
          Salva
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogModificaCatalogo;
